import styled from 'styled-components';

export const Wrapper = styled.div``;

export const LogoBox = styled.div`
  cursor: pointer;
  width: 200px;
  height: 200px;
`;

export const UploadWrapper = styled.div`
  height: 120px;
  width: 120px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgb(243, 247, 255);
  border: 1px dashed ${({ theme }) => theme.colors.lightGrey};
`;

export const UploadMessage = styled.p`
  font-size: 14px;
  color: #a7a7a7;
  font-weight: 400;
  letter-spacing: 0.5px;
  padding: 6px;
  text-align: center;
`;
